import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import Axios from "../apis/axios";
import { NodeId } from "components/NodeId";
import { produce } from "immer";

const createSiteSlice = (set: (data: any) => void, get: () => any) => ({
  sites: {},

  //Start of siteConfig
  createSiteConfig: async (payload: any) => {
    const commandObjects: any[] = [];

    const siteCommandObject: any = {
      nodeId: payload.nodeid ? payload.nodeid : "",
      payload: payload,
      type: "create",
      task: "processCreateSiteConfigCommand",
    };
    commandObjects.push(siteCommandObject);

    const promises = await get().enqueueCommands(commandObjects);

    return promises;
  },

  processCreateSiteConfigCommand: async (commandObject: any) => {
    try {
      const response = await Axios.post(
        "api/v1/sites/create",
        commandObject.payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response?.status === 200) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  //Start of siteConfig
  updateSiteConfig: async (nodeid: any, payload: any) => {
    if (payload.lang === undefined) {
      payload.lang = get().lang;
    }

    if (nodeid === "") {
      nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
    }

    const commandObjects: any[] = [];

    const siteCommandObject: any = {
      nodeId: nodeid ? nodeid : "",
      payload: payload,
      type: "put",
      task: "processUpdateSiteConfigCommand",
    };
    commandObjects.push(siteCommandObject);

    const promises = await get().enqueueCommands(commandObjects);

    return promises;
  },

  processUpdateSiteConfigCommand: async (commandObject: any) => {
    try {
      const encodedReportNodeId = encodeURIComponent(
        commandObject.nodeId || ""
      );

      const response = await Axios.put(
        "api/v1/sites/" + encodedReportNodeId,
        commandObject.payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response?.status === 200) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  deleteSiteConfiguration: async (payload: any) => {
    const deleteCommandObject = {
      payload: payload,
      type: "delete",
      task: "processDeleteSiteConfigCommand",
    };
    let promises = get().enqueueCommands([deleteCommandObject]);

    return promises;
  },

  processDeleteSiteConfigCommand: async (commandObject: any) => {
    try {
      const encodedSiteNodeId = encodeURIComponent(
        commandObject.payload.sitenodeid || ""
      );

      const response = await Axios.delete(
        "/api/v1/sites/" + encodedSiteNodeId,

        {
          data: {
            legalentitynodeid: commandObject.payload.legalentitynodeid,
          },
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response?.status === 200) {
        return;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  //Start of reports
  getAllSites: async () => {
    try {
      if (get().isAuthUser === true) {
        const response = await Axios.get(`api/v1/sites`, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response && response?.status == 200) {
          set(
            produce((state: any) => {
              state.sites = response.data;
            })
          );
          // Return the response data after updating the state
          return response.data;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },
});

export default createSiteSlice;
